if (!customElements.get('share-button')) {
  customElements.define(
    'share-button',
    class ShareButton extends (window.DetailsDisclosure || HTMLElement) {
      constructor() {
        super();

        this.elements = {
          shareButton: this.querySelector('button.share-button__button'),
          shareSummary: this.querySelector('summary'),
          closeButton: this.querySelector('.share-button__close'),
          successMessage: this.querySelector('[id^="ShareMessage"]'),
          urlInput: this.querySelector('input'),
        };
        this.urlToShare = this.elements.urlInput ? this.elements.urlInput.value : document.location.href;

        if (!this.mainDetailsToggle) {
          this.mainDetailsToggle = this.querySelector('details');
        }

        if (navigator.share) {
          if (this.mainDetailsToggle) this.mainDetailsToggle.setAttribute('hidden', '');
          if (this.elements.shareButton) {
            this.elements.shareButton.classList.remove('hidden');
            this.elements.shareButton.addEventListener('click', () => {
              navigator.share({ url: this.urlToShare, title: document.title });
            });
          }
        } else if (this.mainDetailsToggle) {
          this.mainDetailsToggle.addEventListener('toggle', this.toggleDetails.bind(this));
          this.mainDetailsToggle
            .querySelector('.share-button__copy')
            ?.addEventListener('click', this.copyToClipboard.bind(this));
          this.mainDetailsToggle
            .querySelector('.share-button__close')
            ?.addEventListener('click', this.close.bind(this));
        }
      }

      toggleDetails() {
        if (!this.mainDetailsToggle?.open) {
          this.elements.successMessage?.classList.add('hidden');
          if (this.elements.successMessage) this.elements.successMessage.textContent = '';
          this.elements.closeButton?.classList.add('hidden');
          this.elements.shareSummary?.focus();
        }
      }

      copyToClipboard() {
        const value = this.elements.urlInput?.value || this.urlToShare;
        navigator.clipboard.writeText(value).then(() => {
          if (this.elements.successMessage) {
            this.elements.successMessage.classList.remove('hidden');
            this.elements.successMessage.textContent =
              window.accessibilityStrings?.shareSuccess || 'Link copied to clipboard';
          }
          this.elements.closeButton?.classList.remove('hidden');
          this.elements.closeButton?.focus();
        });
      }

      close() {
        if (typeof super.close === 'function') {
          super.close();
          return;
        }
        if (!this.mainDetailsToggle) return;
        this.mainDetailsToggle.removeAttribute('open');
        this.elements.shareSummary?.setAttribute('aria-expanded', false);
      }

      updateUrl(url) {
        this.urlToShare = url;
        if (this.elements.urlInput) this.elements.urlInput.value = url;
      }
    }
  );
}
